export const MAX_SAVED_REPLIES = 60;
export const MAX_SAVED_REPLY_TITLE = 64;
export const MAX_SAVED_REPLY_BODY = 5000;

export const normalizeSavedReplies = (items) => {
  const seen = new Set();
  const replies = [];
  for (const raw of Array.isArray(items) ? items : []) {
    const title = String(raw?.title || '').replace(/\s+/g, ' ').trim().slice(0, MAX_SAVED_REPLY_TITLE);
    const body = String(raw?.body || '').trim().slice(0, MAX_SAVED_REPLY_BODY);
    const id = String(raw?.id || '').trim();
    if (!id || !title || !body || seen.has(id)) continue;
    seen.add(id);
    replies.push({
      id,
      title,
      body,
      created_at: raw.created_at || new Date().toISOString(),
      updated_at: raw.updated_at || raw.created_at || new Date().toISOString(),
    });
    if (replies.length === MAX_SAVED_REPLIES) break;
  }
  return replies;
};

export const savedRepliesUrl = (tenantId, isMasterAdmin) => {
  const query = isMasterAdmin && tenantId
    ? `?tenant_id=${encodeURIComponent(tenantId)}` : '';
  return `/api/chat/saved-replies${query}`;
};
